// MRS Builders content + shared motion variants

export const NAV_LINKS = [
  { label: "Philosophy", href: "#philosophy" },
  { label: "Services", href: "#services" },
  { label: "Approach", href: "#approach" },
  { label: "Process", href: "#process" },
  { label: "Packages", href: "#packages" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    no: "01",
    title: "Residential Interiors",
    desc: "Villas, apartments & homes; warm minimalism woven with biophilic textures.",
  },
  {
    no: "02",
    title: "Commercial & Office Interiors",
    desc: "GCC-ready offices and retail spaces designed for wellbeing, not just work.",
  },
  {
    no: "03",
    title: "Exterior & Landscape Design",
    desc: "Terracotta panels, stone cladding, jaali screens and planted facades.",
  },
  {
    no: "04",
    title: "Murals & 3D Wall Work",
    desc: "Hand-painted art and organic plaster relief inspired by natural forms.",
  },
  {
    no: "05",
    title: "Courtyard & Garden Design",
    desc: "Private green pockets designed into the heart of your home or office.",
  },
];

export const APPROACH = [
  { title: "Any Material, Any Style", desc: "Marble, glass, metal or wood — designed in whatever aesthetic you love." },
  { title: "A Living Element, Always", desc: "A statement plant, living wall or green corner in every project." },
  { title: "Natural Light, By Design", desc: "Skylights and open layouts that invite daylight in, in any style." },
  { title: "Scalable Greenery", desc: "One sculptural plant or an entire courtyard garden — tailored to your space." },
  { title: "Water as an Accent", desc: "Fountains or reflecting pools, for an extra layer of calm." },
  { title: "Luxury, Uncompromised", desc: "Premium finishes that prioritise nature, woven in seamlessly." },
];

export const MARQUEE_ITEMS = [
  "Any Material, Any Style",
  "A Living Element, Always",
  "Natural Light By Design",
  "Scalable Greenery",
  "Water as an Accent",
  "Luxury Uncompromised",
];

export const DIFFERENCE = [
  { title: "One Team, Full Scope", desc: "Interiors, exteriors, murals & 3D art all under one roof. No vendor juggling.", span: "lg:col-span-7" },
  { title: "Dedicated Project Manager", desc: "One point of contact from first sketch to final handover. Weekly updates.", span: "lg:col-span-5" },
  { title: "Site Analysis & Gauging", desc: "Years of local sourcing knowledge, used to plan your space right the first time.", span: "lg:col-span-5" },
  { title: "Full Documentation & Transparency", desc: "Milestone-based contracts and complete paperwork, every step of the way.", span: "lg:col-span-7" },
  { title: "Premium Materials, Upfront", desc: "Named brands and finishes specified before we begin — no vague promises.", span: "lg:col-span-6" },
  { title: "Post-Handover Warranty", desc: "Workmanship warranty and ongoing support. We stand behind every project.", span: "lg:col-span-6" },
];

export const PROCESS = [
  { no: "01", title: "Discovery", desc: "Site visit, scope & lifestyle needs understood before we advise anything." },
  { no: "02", title: "Design", desc: "Photorealistic renders & material selection. You see it before we build." },
  { no: "03", title: "Approval", desc: "Milestone contract, payment schedule and full documentation." },
  { no: "04", title: "Execution", desc: "Weekly updates, photo logs, quality audits at every stage." },
  { no: "05", title: "Handover", desc: "Snagging cleared, warranty docs, and a space that feels alive." },
];

export const STATS = [
  { value: "4 to 10", unit: "wks", label: "Typical interior timeline" },
  { value: "Weekly", unit: "", label: "Progress reports to you" },
  { value: "2 to 4", unit: "renders", label: "Before execution begins" },
  { value: "Zero", unit: "", label: "Hidden costs or surprises" },
];

export const RESIDENTIAL = [
  { bhk: "1 BHK", basic: "4 L", mid: "8 L", premium: "12–15 L" },
  { bhk: "2 BHK", basic: "7 L", mid: "12 L", premium: "16–18 L" },
  { bhk: "3 BHK", basic: "10 L", mid: "14 L", premium: "20 L" },
  { bhk: "4 BHK & More", basic: "14 L", mid: "18 L", premium: "24 L" },
];

export const TIERS = [
  { key: "basic", name: "Basic", note: "Laminates, basic modular kitchen, simple wardrobes, minimal design work." },
  { key: "mid", name: "Mid-Range", note: "Better finishes (acrylic, HDHMR), good false ceilings, lighting, natural accents.", featured: true },
  { key: "premium", name: "Premium", note: "Veneer, PU polish, Italian finishes, fully customised biophilic design work." },
];

export const COMMERCIAL = [
  { tier: "Basic", rate: "1,000 – 1,400" },
  { tier: "Mid-Range", rate: "1,600 – 2,600" },
  { tier: "Premium", rate: "2,600 – 3,600" },
];

export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1634822929331-ee4dc2c97fc4", label: "Living Spaces" },
  { url: "https://images.unsplash.com/photo-1718220268527-4477fd170775", label: "Biophilic Atriums" },
  { url: "https://images.unsplash.com/photo-1552084850-3c5b6222bbe8", label: "Architectural Detail" },
  { url: "https://images.pexels.com/photos/8134745/pexels-photo-8134745.jpeg", label: "Exteriors & Landscape" },
];

export const SERVICE_OPTIONS = [
  "Residential Interiors",
  "Commercial & Office Interiors",
  "Exterior & Landscape Design",
  "Murals & 3D Wall Work",
  "Courtyard & Garden Design",
  "Not sure yet",
];

export const CONTACT = {
  phone: "+91 96064 77181",
  whatsapp: "https://wa.me/919606477181",
  email: "hello@mrsbuilders.biz",
  locations: ["Bangalore", "Mangalore"],
};

// Shared framer-motion variants
export const EASE = [0.16, 1, 0.3, 1];

export const revealUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: EASE, delay: i * 0.08 },
  }),
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1, ease: EASE } },
};
